import styled from 'styled-components';

const profileStyledComponent = styled.div``;

export default profileStyledComponent;
